import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/state/store';

import type { CoreState } from './types';

export const getCoreState = (state: RootState): CoreState => state.core;

export const getDrawerWidth = createSelector(getCoreState, (state: CoreState) => state.drawerWidth);
